/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  AssistantMCPServerRef,
  AssistantMCPServerRef$Outbound,
  AssistantMCPServerRef$outboundSchema,
} from "./assistantmcpserverref.js";
import {
  AssistantToolsetRef,
  AssistantToolsetRef$Outbound,
  AssistantToolsetRef$outboundSchema,
} from "./assistanttoolsetref.js";

/**
 * Optional initial status.
 */
export const CreateAssistantFormStatus = {
  Active: "active",
  Paused: "paused",
} as const;
/**
 * Optional initial status.
 */
export type CreateAssistantFormStatus = ClosedEnum<
  typeof CreateAssistantFormStatus
>;

export type CreateAssistantForm = {
  /**
   * The system instructions for the assistant.
   */
  instructions: string;
  /**
   * Optional maximum active warm runtimes.
   */
  maxConcurrency?: number | undefined;
  /**
   * MCP servers to attach. When sent, replaces the assistant's servers that are not hosted (toolset-backed). A hosted server listed here is attached if it is not already; attached hosted servers are left unchanged, and toolsets governs them when both are sent.
   */
  mcpServers?: Array<AssistantMCPServerRef> | undefined;
  /**
   * The model identifier used by the assistant.
   */
  model: string;
  /**
   * The assistant name.
   */
  name: string;
  /**
   * Optional initial status.
   */
  status?: CreateAssistantFormStatus | undefined;
  /**
   * Hosted (toolset-backed) MCP servers to attach, by toolset slug. When sent, replaces the assistant's hosted servers.
   */
  toolsets: Array<AssistantToolsetRef>;
  /**
   * Optional warm runtime TTL in seconds.
   */
  warmTtlSeconds?: number | undefined;
};

/** @internal */
export const CreateAssistantFormStatus$outboundSchema: z.ZodMiniEnum<
  typeof CreateAssistantFormStatus
> = z.enum(CreateAssistantFormStatus);

/** @internal */
export type CreateAssistantForm$Outbound = {
  instructions: string;
  max_concurrency?: number | undefined;
  mcp_servers?: Array<AssistantMCPServerRef$Outbound> | undefined;
  model: string;
  name: string;
  status?: string | undefined;
  toolsets: Array<AssistantToolsetRef$Outbound>;
  warm_ttl_seconds?: number | undefined;
};

/** @internal */
export const CreateAssistantForm$outboundSchema: z.ZodMiniType<
  CreateAssistantForm$Outbound,
  CreateAssistantForm
> = z.pipe(
  z.object({
    instructions: z.string(),
    maxConcurrency: z.optional(z.int()),
    mcpServers: z.optional(z.array(AssistantMCPServerRef$outboundSchema)),
    model: z.string(),
    name: z.string(),
    status: z.optional(CreateAssistantFormStatus$outboundSchema),
    toolsets: z.array(AssistantToolsetRef$outboundSchema),
    warmTtlSeconds: z.optional(z.int()),
  }),
  z.transform((v) => {
    return remap$(v, {
      maxConcurrency: "max_concurrency",
      mcpServers: "mcp_servers",
      warmTtlSeconds: "warm_ttl_seconds",
    });
  }),
);

export function createAssistantFormToJSON(
  createAssistantForm: CreateAssistantForm,
): string {
  return JSON.stringify(
    CreateAssistantForm$outboundSchema.parse(createAssistantForm),
  );
}
